import {useEffect, useState} from 'react';

const TABLET_WIDTH = 768;
const isMobileWidth = () =>
  typeof window !== 'undefined' && window.innerWidth < TABLET_WIDTH;

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (isMobileWidth() !== isMobile) {
        setIsMobile(!isMobile);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile, setIsMobile]);

  return isMobile;
};
